import MenuItem from "@mui/material/MenuItem";
import React, {useEffect} from "react";
import {useState} from "react";
import { saveGridColumnLayout } from "../columnLayoutPersistence";

const ColDisplayMenuItem = ({colDef, columnApi, layoutScope, onUpdate}) => {
  // Initialize state based on current colDef.hide value
  const [colVisible, setColVisible] = useState(!colDef.hide);
  const columnId = colDef.colId || colDef.field;
  
  // Update local state when component is re-mounted (due to key change in parent)
  useEffect(() => {
    setColVisible(!colDef.hide);
  }, [colDef.hide]);

  return <MenuItem onClick={() => {
    if (!columnId) {
      return;
    }

    let nowHidden = colDef.hide == false || colDef.hide == undefined;
    setColVisible(!nowHidden);
    columnApi.setColumnVisible(columnId, !nowHidden);
    saveGridColumnLayout(columnApi, layoutScope);
    onUpdate()
  }}>
    <input
      type="checkbox"
      checked={colVisible}
      onChange={() => {
      }}
      readOnly
    >
    </input>
    {colDef.headerName}
  </MenuItem>
};

export default ColDisplayMenuItem;